import axios from "axios";
import config from "../../../config";

const API_URL = "https://portfolio.primevp.in/api/v1";
const token = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIyYjdlMTZhMC02NmZmLTExZWMtOThhOC0zM2I3ZDQ5ZmNiZDYiLCJpYXQiOjE2NTg5MTYxNDUsImV4cCI6MTY5MDQ1MjE0NSwiYXVkIjoiYXBwLnByaW1ldnAuaW4iLCJpc3MiOiJhcGkucHJpbWV2cC5pbiJ9.RLTGvZM6GwVtnUPRNHzf-o5lL7hj30Jbqs3CI6V83So`;

const getCompaniesListStart = () => {
  return {
    type: "GET_COMPANIES_LIST_START",
  };
};

const getCompaniesListSuccess = ({ data }) => {
  return {
    type: "GET_COMPANIES_LIST_SUCCESS",
    data,
  };
};

const getCompaniesListFail = () => {
  return {
    type: "GET_COMPANIES_LIST_FAIL",
  };
};

const getCompanyMetricsFail = () => {
  return {
    type: "GET_COMPANY_METRICS_FAIL",
  };
};

const getCompanyMetricsStart = () => {
  return {
    type: "GET_COMPANY_METRICS_START",
  };
};

const getCompanyMetricsSuccess = ({ data }) => {
  return {
    type: "GET_COMPANY_METRICS_SUCCESS",
    data,
  };
};

export function getCompaniesList() {
  return (dispatch, getState) => {
    dispatch(getCompaniesListStart());

    const { login } = getState();

    axios
      .get(`${API_URL}/company/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((resp) => {
        dispatch(getCompaniesListSuccess({ data: resp.data }));
      })
      .catch((ex) => {
        console.log("Failed to post user", ex);
        dispatch(getCompaniesListFail());
      });
  };
}

// Send reminder
export const sendReminder = (companyId, ccPartner) => {
  return (dispatch, getState) => {
    dispatch({
      type: "SEND_REMINDER_LOADING",
      payload: true,
    });

    const { login } = getState();
    axios
      .post(
        `${API_URL}/company/${companyId}/reminder`,
        {
          ccPartner,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((resp) => {
        dispatch({
          type: "SEND_REMINDER",
          payload: resp.data,
        });
      })
      .catch((ex) => {
        console.log("Failed to send reminder", ex);
        dispatch({
          type: "SEND_REMINDER",
          payload: ex,
          error: true,
        });
      });
  };
};

export function getCompanyMetrics(companyId) {
  return (dispatch, getState) => {
    dispatch(getCompanyMetricsStart());

    const { login } = getState();

    axios
      .get(`${API_URL}/company/${companyId}/metrics`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((resp) => {
        console.log(resp, "responsessss");
        dispatch(getCompanyMetricsSuccess({ data: resp.data }));
      })
      .catch((ex) => {
        console.log("Failed to get Fund metrics", ex);
        dispatch(getCompanyMetricsFail());
      });
  };
}

export const resetReminderStatus = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_REMINDER_STATUS", payload: false });
  };
};
